import { render } from "./PrizesAndGrants.vue?vue&type=template&id=79de5cd0"
import script from "./PrizesAndGrants.vue?vue&type=script&lang=js"
export * from "./PrizesAndGrants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__